module.exports = __webpack_public_path__ + "middle-6f61b6bde5c4306d27c54eab3e560ce2.png";